// Lo que viene del BE (API_GET_SERVICE_NAME)
export type MinimalService = {
  id: number;
  service_name: string;
  backoffice_active?: boolean;
};

// Lo que queremos tener en el store y en toda la app
export type EnrichedBusiness = MinimalService & {
  key: string;
  displayName: string;
  color?: string;
  iconKey?: string;
};

// Mapa para traducir nombres largos del BE a tus claves internas (sd, utim, oc)
const KEY_NORMALIZATION: Record<string, string> = {
  "salud domiciliaria": "sd",
  "utim": "utim",
  "operaciones complejas": "oc",
  "rmi": "rmi",
  "aeropuertos": "airports",
};

const toKey = (name: string) => {
  const cleanName = (name || "").trim().toLowerCase();
  return KEY_NORMALIZATION[cleanName] ?? cleanName;
};

// Mapeo local para agregar color, icono, displayName “lindo”
const KNOWN: Record<string, { displayName: string; color?: string; iconKey?: string }> = {
  sd: {
    displayName: "Salud domiciliaria",
    color: "#7086FD",
    iconKey: "iconDomiciliaryHealth",
  },
  oc: {
    displayName: "Operaciones complejas",
    color: "#7EDBA2",
    iconKey: "iconMountain",
  },
  utim: {
    displayName: "UTIM",
    color: "#FFAE4C",
    iconKey: "iconAmbulance",
  },
  airports: {
    displayName: "Aeropuertos",
    color: "#1A8CAD",
    iconKey: "iconPlane",
  },
};

export const adaptBusiness = (b: MinimalService): EnrichedBusiness => {
  const key = toKey(b.service_name);
  const known = KNOWN[key];

  return {
    ...b,
    key,
    displayName: known?.displayName ?? b.service_name ?? String(b.id),
    color: known?.color,
    iconKey: known?.iconKey,
  };
};

export const adaptBusinessList = (list: MinimalService[]): EnrichedBusiness[] =>
  (list || []).map(adaptBusiness);
